import { Injectable } from '@angular/core';
import { Firestore, collection, addDoc, doc, setDoc, getDocs } from '@angular/fire/firestore';
import { AssessmentResult } from '../models/assessment.model';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  constructor(private firestore: Firestore) {}

  async saveAssessment(assessment: AssessmentResult): Promise<string> {
    try {
      const assessmentsCollection = collection(this.firestore, 'assessments');
      const docRef = await addDoc(assessmentsCollection, {
        ...assessment,
        timestamp: assessment.timestamp.toISOString()
      });
      return docRef.id;
    } catch (error) {
      console.error('Error saving assessment:', error);
      throw error;
    }
  }

  async updateAssessment(id: string, assessment: Partial<AssessmentResult>): Promise<void> {
    try {
      const docRef = doc(this.firestore, 'assessments', id);
      await setDoc(docRef, assessment, { merge: true });
    } catch (error) {
      console.error('Error updating assessment:', error);
      throw error;
    }
  }

  // Get all assessments (optional, for future use)
  async getAssessments(): Promise<AssessmentResult[]> {
    try {
      const assessmentsCollection = collection(this.firestore, 'assessments');
      const snapshot = await getDocs(assessmentsCollection);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data() as AssessmentResult,
        timestamp: new Date(doc.data()['timestamp'])
      }));
    } catch (error) {
      console.error('Error fetching assessments:', error);
      throw error;
    }
  }

  // Method to set up dashboard password hash (admin function)
  async setDashboardPassword(passwordHash: string): Promise<void> {
    try {
      const authDoc = doc(this.firestore, 'auth', 'dashboard');
      await setDoc(authDoc, { passwordHash: passwordHash });
      console.log('Dashboard password hash set successfully');
    } catch (error) {
      console.error('Error setting dashboard password:', error);
      throw error;
    }
  }
}